import { plainText } from './material'

// Matching words, the same for people (⌘K) and the AI (`search`): what one
// finds, the other finds too. Literal, case-insensitive, Kangxi radicals folded.
// Card text is markdown: emphasis and escapes are not part of the words, so
// "**B**uccal" is found by "buccal".

const fold = (s: string) =>
  plainText(s)
    .toLowerCase()
    .replace(/[*_~`\\]/g, '')

/** How well `text` matches: 0 none; a word per point; the whole query beats any words. */
export function matcher(query: string): (text: string) => number {
  const q = fold(query).trim()
  const terms = q.split(/\s+/).filter(Boolean)
  return (text: string) => {
    if (!terms.length) return 0
    const low = fold(text)
    if (low.includes(q)) return terms.length + 1
    return terms.filter((w) => low.includes(w)).length
  }
}

/** A line of card markdown as people read it: no markers, links as their text. */
export function readableLine(md: string): string {
  return md
    .replace(/^\s*(#+|[-*+]\s+\[[ xX]\]|[-*+]|\d+\.|>)\s+/, '')
    .replace(/!?\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\*\*|__|~~|`/g, '')
    .replace(/(^|[^\w*])[*_](?=\S)([^*_]*?\S)[*_](?![\w*])/g, '$1$2')
    .replace(/\\([\\`*_{}[\]()#+\-.!>|~])/g, '$1')
    .trim()
}
